export const themeKey = 'Theme';
export type Theme = 'DARK' | 'LIGHT';

const sgbsVersion = import.meta.env.VITE_SGBS_VERSION;
const cdnUrl = `https://sgwt-cdn-sgbs.sgmarkets.com/sg-bootstrap/${sgbsVersion}`;

function variableSgbsUrls(theme: string | null) {
  const variation = theme === 'DARK' ? 'dark' : 'standard';
  return {
    sgbs: `${cdnUrl}/core/css/sg-bootstrap-${variation}.min.css`,
    aggrid: `${cdnUrl}/ag-grid-theme/27-${variation}.min.css`,
    icons: `${cdnUrl}/icons/index.min.css`,
  }
}

export function initSgBootstrap(theme?: Theme) {
  updateThemeUrls(theme ?? getTheme());
  appendUniqueLinkToDocument('icons', `${cdnUrl}/icons/index.min.css`);
}

function updateThemeUrls(theme: Theme) {
  Object.entries(variableSgbsUrls(theme)).forEach(([id, url]) => {
    appendUniqueLinkToDocument(id, url);
  });
}

export function setTheme(theme: Theme) {
  updateThemeUrls(theme);
  saveToLocalStorage(theme);
}

export function getTheme(): Theme {
  const savedTheme = getFromLocalStorage();
  if (savedTheme != null) {
    return savedTheme?.toUpperCase() === 'DARK' ? 'DARK' : 'LIGHT';
  }
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  return prefersDark ? 'DARK' : 'LIGHT';
}

function saveToLocalStorage(theme: Theme) {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(themeKey, theme);
  } catch {
    console.error('Unable to store theme, localStorage might be full');
  }
}

function getFromLocalStorage(): string | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem(themeKey);
}

function appendUniqueLinkToDocument(id: string, url: string) {
  const linkElement = document.querySelector<HTMLLinkElement>(`link[id="${id}"]`);
  const newLinkElement = document.createElement('link');
  newLinkElement.rel = 'stylesheet';
  newLinkElement.id = id;
  newLinkElement.href = url;
  if (linkElement !== null) {
    newLinkElement.onload = () => {
      document.head.removeChild(linkElement);
    };
  }
  document.head.appendChild(newLinkElement);
}